﻿import { GuiAuswertung } from "./GuiAuswertung";
import { IChartData } from "../Interface/IChartData"
import { Chart } from "../chart-setup";
export class GuiAuswertungAbfallKosten extends GuiAuswertung {
    chart?: Chart;

    constructor() {
        super("GuiAuswertungAbfallKosten");
    }

    override draw() {

        const ctx = document.getElementById("chartAbfallKosten") as HTMLCanvasElement;
        if (this.chart != undefined) {
            this.chart.destroy();
        }

        const jsonData = (document.getElementById("jsonAbfallKosten") as HTMLInputElement).value;
        if (jsonData == undefined || jsonData === "null") { return; }

        const barData = JSON.parse(jsonData) as IChartData;
        const data = {
            labels: barData.labels,
            datasets: [{
                label: "",
                data: barData.values,
                backgroundColor: barData.colors,
                hoverOffset: 4
            }]
        };

        // valuesArePercent ist hier serverseitig false: Kosten koennen negativ sein
        // (Gutschriften/Erloese), Anteile waeren irrefuehrend.
        // responsive: false wie bisher - das Layout dieser Seite haengt daran.
        this.chart = new Chart(ctx, this.CreateDoughnutConfig(data, barData.valuesArePercent, false));
    }
}
